import {Group2DFacade} from 'troika-2d'
import {
  GRAPH_STROKE_STYLES,
  interpolateTimelineValues
} from '../../constants'
// import { interpolateRgbBasis } from 'd3-interpolate'
import Path2D from './Path2D'

const timeScaleInterpolator = (fromObj, toObj, progress) => {
  const [fromFloor, fromCeil] = fromObj.domain()
  const [toFloor, toCeil] = toObj.domain()
  if (fromObj && toObj) {
    return toObj.copy().domain([
      new Date(+toFloor - ((+toFloor - +fromFloor) * (1 - progress))),
      new Date(+toCeil + ((+fromCeil - +toCeil) * (1 - progress)))
    ])
  }
  return toObj
}

const linearScaleInterpolator = (fromObj, toObj, progress) => {
  const [fromFloor, fromCeil] = fromObj.domain()
  const [toFloor, toCeil] = toObj.domain()
  if (fromObj && toObj) {
    return toObj.copy().domain([
      toFloor - ((toFloor - fromFloor) * (1 - progress)),
      toCeil + ((fromCeil - toCeil) * (1 - progress))
    ])
  }
  return toObj
}

class StackedStreams extends Group2DFacade {
  /**
   * @property renderData
   * @property onPathMouseOver
   * @property onPathMouseOver
   * @property onPathMouseMove
   * @property xScale
   * @property yScale
   * @property minX
   * @property maxX
   * @property minY
   * @property maxY
   * @property yFieldKeysToStyles
   * @property pathInterpolate
   * @property highlightedPathKey
   */

  highlightedPathKey = ""

  constructor(parent) {
    super(parent)
  }

  /**
   * @template
   */
  onPathMouseOver() {}

  /**
   * @template
   */
  onPathMouseMove() {}

  /**
   * @template
   */
  onPathMouseOut() {}

  afterUpdate() {
    const {
      renderData,
      xScale,
      yScale,
      minX,
      maxX,
      minY,
      maxY,
      yFieldKeysToStyles,
      pathInterpolate,
      highlightedPathKey
    } = this

    const xRange = xScale.range()
    const yRange = yScale.range()

    this.children = renderData.toArray().map(line => {
      const dataKey = line.dataKey
      const isHighlighted = highlightedPathKey === dataKey

      const {
        fillColor,
        fillStyle,
        fillOpacity,

        strokeColor,
        strokeWidth,
        strokeStyle,
        strokeOpacity
      } = yFieldKeysToStyles.get(dataKey).toJS()

      return {
        key: dataKey,
        facade: Path2D,
        dataKey,
        values: line.values,

        isHighlighted,

        fillColor: isHighlighted ? '#ffffcc' : fillColor,
        fillStyle: fillStyle,
        fillOpacity: fillOpacity,

        strokeColor: isHighlighted ? '#ffffff' : strokeColor,
        strokeWidth: isHighlighted ? (strokeWidth * 2) : strokeWidth,
        strokeStyle: isHighlighted ? GRAPH_STROKE_STYLES.SOLID : strokeStyle,
        strokeOpacity: isHighlighted ? 1.0 : strokeOpacity,

        // dashOffset: 0.0,
        strokeAnimationT: 0.0,

        pathInterpolate,
        xScale,
        yScale,

        xRange,
        yRange,
        minX,
        maxX,
        minY,
        maxY,

        onMouseMove: this.onPathMouseMove,
        onMouseOver: this.onPathMouseOver,
        onMouseOut: this.onPathMouseOut,

        transition: {
          strokeWidth: {
            duration: 200,
            easing: 'easeOutBack',
          },
          // fillColor: {
          //   duration: 1000,
          //   // easing: 'easeInOutCubic',
          //   interpolate: interpolateRgbBasis
          // },
          values: {
            duration: 500,
            easing: 'easeOutExpo',
            interpolate: interpolateTimelineValues
          },
          xScale: {
            duration: 1000,
            easing: 'easeOutExpo',
            interpolate: timeScaleInterpolator
          },
          yScale: {
            duration: 1000,
            easing: 'easeOutExpo',
            interpolate: linearScaleInterpolator
          }
        },
        animation: {
          0: {
            strokeAnimationT: 0.0 // Should equal the dashArray values summed
          },
          100: {
            strokeAnimationT: 1.0
          },
          duration: 5000,
          iterations: Infinity,
          delay: 0
        }
      }
    })

    super.afterUpdate()
  }
}


export default StackedStreams
